module.exports = __webpack_public_path__ + "authenticate.svg?8e9f67db24f716bc40db874234b799a3";